module.exports = __webpack_public_path__ + "13ced3742d51f6819c71dc9548594d4e.svg";